import { render, staticRenderFns } from "./TagManager.vue?vue&type=template&id=b690efe4&scoped=true"
import script from "./TagManager.vue?vue&type=script&lang=js"
export * from "./TagManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b690efe4",
  null
  
)

export default component.exports